import { lazy } from 'react';

export const PdpRespAuctionUrgencyInfoLazy = lazy(
    () =>
        import(
            /* webpackChunkName: "PdpRespAuctionUrgencyInfoLazy" */ './PdpRespAuctionUrgencyInfo'
        )
);
